import { cn } from '@commenda/utils';
import { ReactNode } from 'react';

interface MoleculeCardProps {
  children: ReactNode;
  className?: string;
}

export const MoleculeCard = ({ children, className }: MoleculeCardProps) => {
  return (
    <div
      className={cn(
        'w-full bg-bg-primary p-3xl border border-border-primary rounded-xl flex flex-col gap-xl',
        className
      )}
    >
      {children}
    </div>
  );
};
